import { trpc } from '@tencent/tpro_rmonitor_product_manager_role';
import { get } from 'lodash-es';
import AbstractHttpClient from '@/infrastructure/axios/request';
import { TrpcService } from '@/service/trpc';
import { WithTypeCast } from '@raft/utils';
type IGetRolesReq = WithTypeCast<trpc.rmonitor.product_manager.IGetRolesReq>;
type IRoleInfo = WithTypeCast<trpc.rmonitor.product_manager.IRoleInfo>;

/**
 * 产品成员管理
 */
export class RoleService extends AbstractHttpClient {
  constructor() {
    super({
      serviceName: TrpcService.RoleService,
    });
  }

  /**
   * 获取所有角色
   */
  public async getRoles(req: IGetRolesReq): Promise<IRoleInfo[]> {
    try {
      const rsp = await this.trpcPost('GetRoles', req);
      return get(rsp, 'roles', []);
    } catch (e) {
      return [];
    }
  }
}

export const roleService = new RoleService();
